import { RealEstateAttachments } from '../../../../@types/real-estate-api-types'
import { AttachmentData, AttachmentStatus, AttachmentType } from '../../../../@types/types'

export const attachmentsToApp = (attachments: RealEstateAttachments[]): AttachmentData[] =>
  attachments.map((it) => {
    let attachmentType = AttachmentType.DOCUMENT
    if (it.picture) attachmentType = AttachmentType.PICTURE
    if (it.link) attachmentType = AttachmentType.LINK
    if (it.video) attachmentType = AttachmentType.VIDEO

    return {
      state: AttachmentStatus.PERSISTED,
      attachmentType: attachmentType,
      ...(it.id && {
        attachment: {
          id: it.id,
          title: it.title,
          url: it.url,
          source: it.source,
          type: attachmentType,
          picture: it.picture,
          document: it.document,
          contentType: it.contentType,
          floorplan: it.floorplan,
          link: it.link,
          linkUrl: it.linkUrl,
          video: it.video,
          offerApiId: it.offerApiId,
          videoId: it.videoId,
        },
      }),
      ...(!it.link && {
        file: {
          id: it.id,
          name: it.title,
          percent: 100,
        },
      }),
    }
  })
